import type { ComponentPropsWithoutRef } from 'react'
import { LosseLink } from '@ubo/losse-sjedel'

export interface ButtonProps extends ComponentPropsWithoutRef<'a'> {
  onClick?: () => void
  to?: string
}

export default function Button({ children, className = '', ...props }: ButtonProps) {
  return (
    <LosseLink className={`${className} btn`} {...props}>
      {children}
    </LosseLink>
  )
}
